import { useContext, useEffect } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { useNavigate } from 'react-router-dom';

/**
 * This chucks the react-router navigate method in to the deprecated agPanelService so it can
 * be used by other services..
 *
 * This is awful, but it means we don't have to rewrite every service right now
 *
 * TODO: delete this once no services need to use navigate
 */
export function useNavigateForServicesInitialisationEffect() {
    const navigate = useNavigate();
    const { agPanelService } = useContext(ServicesContext);
    useEffect(() => {
        agPanelService.initialiseNavigate(navigate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
